import { Injectable } from '@angular/core';
import { DashboardWithRelations as Dashboard } from '@osos/shared/api';
import { DashboardEntryPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { DashboardParserV1Service } from '../../parsers/dashboard-parser/dashboard-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable()
export class DashboardFactoryService extends FactoryBase<
  Dashboard,
  DashboardEntryPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: DashboardParserV1Service,
  ) {
    super(parserFactory);
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: DashboardEntryPresenterModel): Dashboard {
    const parser = this.getParser(Dashboard, DashboardEntryPresenterModel);
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(presenter: Dashboard): DashboardEntryPresenterModel {
    const parser = this.getParser(Dashboard, DashboardEntryPresenterModel);
    const result = parser.getPresenterModel(presenter);
    return result;
  }
}
